import React, { useState } from "react";

export interface MockupType {
  templateData?: any;
}

function Mockup({ templateData }: MockupType) {
  const [activeTab, setActiveTab] = useState("ios");

  const data = templateData;

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f5f5f7",
        padding: "20px 40px",
      }}
    >
      <div className="container">
        {/* Platform Tabs */}
        <div className="d-flex justify-content-center mb-3">
          <div
            style={{
              background: "white",
              borderRadius: "6px",
              padding: "4px",
              boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
              display: "inline-flex",
              gap: "6px",
            }}
          >
            <button
              onClick={() => setActiveTab("ios")}
              style={{
                border: "none",
                background: activeTab === "ios" ? "#1d1d1f" : "transparent",
                color: activeTab === "ios" ? "white" : "#1d1d1f",
                padding: "4px 6px",
                borderRadius: "6px",
                fontSize: "15px",
                fontWeight: "600",
                cursor: "pointer",
                transition: "all 0.3s ease",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              {/* <span style={{ fontSize: "20px" }}>🍎</span> */}
              iOS
            </button>
            <button
              onClick={() => setActiveTab("android")}
              style={{
                border: "none",
                background: activeTab === "android" ? "#1d1d1f" : "transparent",
                color: activeTab === "android" ? "white" : "#1d1d1f",
                padding: "4px 6px",
                borderRadius: "6px",
                fontSize: "15px",
                fontWeight: "600",
                cursor: "pointer",
                transition: "all 0.3s ease",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              {/* <span style={{ fontSize: "20px" }}>📱</span> */}
              Android
            </button>
          </div>
        </div>

        {/* Mockup Container */}
        <div className="row justify-content-center">
          <div className="col-12">
            <div className="row g-4 align-items-center justify-items-center">
              {/* Phone Mockup */}
              <div className="col-12 px-0 px-md-5">
                {activeTab === "android" ? (
                  <AndroidMockup data={data} />
                ) : (
                  <IOSMockup data={data} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function AndroidMockup({ data }: any) {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div
      style={{
        //   maxWidth: "340px",
        margin: "0 auto",
        filter: "drop-shadow(0 20px 40px rgba(0,0,0,0.15))",
      }}
    >
      {/* Phone Frame */}
      <div
        style={{
          background: "#1f1f1f",
          borderRadius: "42px",
          padding: "12px",
          position: "relative",
        }}
      >
        {/* Camera Cutout */}
        <div
          style={{
            position: "absolute",
            top: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            width: "24px",
            height: "24px",
            background: "#0a0a0a",
            borderRadius: "50%",
            zIndex: 10,
            border: "2px solid #2f2f2f",
          }}
        />

        {/* Screen */}
        <div
          style={{
            background: "linear-gradient(180deg, #e3f2fd 0%, #bbdefb 100%)",
            borderRadius: "34px",
            overflow: "hidden",
            position: "relative",
          }}
        >
          {/* Status Bar */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px 20px",
              paddingTop: "12px",
            }}
          >
            <div
              style={{ fontSize: "14px", fontWeight: "600", color: "#1a1a1a" }}
            >
              9:41
            </div>
            <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="#1a1a1a">
                <path d="M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z" />
              </svg>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="#1a1a1a">
                <path d="M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8l3 3 3-3c-1.65-1.66-4.34-1.66-6 0zm-4-4l2 2c2.76-2.76 7.24-2.76 10 0l2-2C15.14 9.14 8.87 9.14 5 13z" />
              </svg>
              <svg width="20" height="16" viewBox="0 0 24 24" fill="#1a1a1a">
                <path d="M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z" />
              </svg>
            </div>
          </div>

          {/* Lock Screen Content */}
          <div style={{ padding: "40px 0 20px", textAlign: "center" }}>
            {data.global_image ? (
              <div></div>
            ) : (
              <>
                <div
                  style={{
                    fontSize: "64px",
                    fontWeight: "300",
                    color: "#1a1a1a",
                    marginBottom: "4px",
                  }}
                >
                  9:41
                </div>
                <div
                  style={{
                    fontSize: "16px",
                    color: "#424242",
                    fontWeight: "500",
                  }}
                >
                  Sunday, November 26
                </div>
              </>
            )}
          </div>

          {/* Notification Card */}
          <div style={{ padding: "0 16px", marginBottom: "20px" }}>
            <div
              style={{
                background: "white",
                borderRadius: "20px",
                overflow: "hidden",
                boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
                transition: "all 0.3s ease",
              }}
            >
              {/* Notification Header */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "14px 16px 10px",
                  background: isExpanded ? "#f8f9fa" : "white",
                  transition: "background 0.3s ease",
                }}
              >
                <div
                  style={{
                    width: "36px",
                    height: "36px",
                    background: "#000",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <span
                    style={{
                      color: "white",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                  >
                    W
                  </span>
                </div>
                <div
                  style={{
                    marginLeft: "12px",
                    flex: 1,
                    minWidth: 0,
                  }}
                >
                  <div
                    style={{
                      fontSize: "14px",
                      fontWeight: "600",
                      color: "#1a1a1a",
                    }}
                  >
                    Whitelion
                  </div>
                  <div
                    style={{
                      fontSize: "12px",
                      color: "#757575",
                    }}
                  >
                    now
                  </div>
                </div>
                <button
                  onClick={() => setIsExpanded(!isExpanded)}
                  style={{
                    background: "transparent",
                    border: "none",
                    padding: "8px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "50%",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.background = "#f0f0f0")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.background = "transparent")
                  }
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    style={{
                      transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "transform 0.3s ease",
                    }}
                  >
                    <path
                      d="M7 10L12 15L17 10"
                      stroke="#424242"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>

              {/* Notification Content */}
              <div style={{ padding: "0 16px 12px" }}>
                <div
                  style={{
                    fontSize: "15px",
                    fontWeight: "600",
                    color: "#1a1a1a",
                    marginBottom: "6px",
                    lineHeight: "1.4",
                  }}
                >
                  {data.headings}
                </div>
                <div
                  style={{
                    fontSize: "14px",
                    color: "#424242",
                    lineHeight: "1.5",
                  }}
                >
                  {data.contents}
                </div>
              </div>

              {/* Notification Image */}
              {data.global_image && (
                <div style={{ padding: "0 16px 16px" }}>
                  <img
                    src={data.global_image}
                    alt="Notification"
                    style={{
                      width: "100%",
                      borderRadius: "12px",
                      display: "block",
                    }}
                  />
                </div>
              )}

              {/* Expanded Actions */}
              {isExpanded && (
                <div
                  style={{
                    borderTop: "1px solid #e0e0e0",
                    padding: "10px 16px",
                    background: "#fafafa",
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "12px",
                  }}
                >
                  <button
                    style={{
                      background: "transparent",
                      border: "none",
                      color: "#1976d2",
                      fontSize: "14px",
                      fontWeight: "600",
                      padding: "6px 12px",
                      cursor: "pointer",
                      borderRadius: "4px",
                    }}
                  >
                    REPLY
                  </button>
                  <button
                    style={{
                      background: "transparent",
                      border: "none",
                      color: "#1976d2",
                      fontSize: "14px",
                      fontWeight: "600",
                      padding: "6px 12px",
                      cursor: "pointer",
                      borderRadius: "4px",
                    }}
                  >
                    OPEN
                  </button>
                </div>
              )}
            </div>
          </div>

          {/* Bottom Space */}
          <div style={{ height: data.global_image ? "280px" : "300px" }} />

          {/* Navigation Bar */}
          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              padding: "12px",
              display: "flex",
              justifyContent: "center",
              gap: "60px",
              background: "rgba(255,255,255,0.5)",
            }}
          >
            <div style={{ fontSize: "20px" }}>◀️</div>
            <div
              style={{
                width: "32px",
                height: "4px",
                background: "#424242",
                borderRadius: "2px",
                marginTop: "8px",
              }}
            />
            <div style={{ fontSize: "20px" }}>☰</div>
          </div>
        </div>
      </div>
    </div>
  );
}

function IOSMockup({ data }: any) {
  return (
    <div
      style={{
        //   maxWidth: "340px",
        margin: "0 auto",
        filter: "drop-shadow(0 20px 40px rgba(0,0,0,0.15))",
      }}
    >
      {/* Phone Frame */}
      <div
        style={{
          background: "#1f1f1f",
          borderRadius: "46px",
          padding: "10px",
          position: "relative",
        }}
      >
        {/* Dynamic Island */}
        <div
          style={{
            position: "absolute",
            top: "18px",
            left: "50%",
            transform: "translateX(-50%)",
            width: "100px",
            height: "28px",
            background: "#000",
            borderRadius: "20px",
            zIndex: 10,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
          }}
        >
          <div
            style={{
              width: "6px",
              height: "6px",
              background: "#333",
              borderRadius: "50%",
            }}
          />
        </div>

        {/* Screen */}
        <div
          style={{
            background: "linear-gradient(180deg, #ffebee 0%, #ffcdd2 100%)",
            borderRadius: "38px",
            overflow: "hidden",
            position: "relative",
          }}
        >
          {/* Status Bar */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px 24px",
              paddingTop: "14px",
            }}
          >
            <div
              style={{ fontSize: "15px", fontWeight: "600", color: "#1a1a1a" }}
            >
              9:41
            </div>
            <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
              <svg width="16" height="12" viewBox="0 0 24 24" fill="#1a1a1a">
                <path d="M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z" />
              </svg>
              <svg width="16" height="12" viewBox="0 0 24 24" fill="#1a1a1a">
                <path d="M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8l3 3 3-3c-1.65-1.66-4.34-1.66-6 0zm-4-4l2 2c2.76-2.76 7.24-2.76 10 0l2-2C15.14 9.14 8.87 9.14 5 13z" />
              </svg>
              <svg width="24" height="12" viewBox="0 0 24 24" fill="#1a1a1a">
                <rect
                  x="2"
                  y="6"
                  width="18"
                  height="11"
                  rx="2"
                  fill="none"
                  stroke="#1a1a1a"
                  strokeWidth="1.5"
                />
                <rect x="20" y="9" width="2" height="5" rx="1" />
                <rect x="4" y="8" width="14" height="7" rx="1" />
              </svg>
            </div>
          </div>

          {/* Lock Screen Time */}
          <div style={{ padding: "50px 0 30px", textAlign: "center" }}>
            {data.global_image ? (
              <div></div>
            ) : (
              <>
                <div
                  style={{
                    fontSize: "72px",
                    fontWeight: "200",
                    color: "#1a1a1a",
                    marginBottom: "0",
                    lineHeight: "1",
                  }}
                >
                  9:41
                </div>
                <div
                  style={{
                    fontSize: "17px",
                    color: "#424242",
                    fontWeight: "500",
                    marginTop: "8px",
                  }}
                >
                  Sunday, November 26
                </div>
              </>
            )}
          </div>

          {/* Notification */}
          <div style={{ padding: "0 16px", marginBottom: "20px" }}>
            <div
              style={{
                background: "rgba(255, 255, 255, 0.75)",
                backdropFilter: "blur(40px)",
                borderRadius: "20px",
                overflow: "hidden",
                boxShadow: "0 8px 30px rgba(0,0,0,0.12)",
              }}
            >
              {/* Header */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "14px 16px 10px",
                }}
              >
                <div
                  style={{
                    width: "36px",
                    height: "36px",
                    background:
                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <span
                    style={{
                      color: "white",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                  >
                    W
                  </span>
                </div>
                <div
                  style={{
                    marginLeft: "12px",
                    flex: 1,
                    minWidth: 0,
                  }}
                >
                  <div
                    style={{
                      fontSize: "13px",
                      fontWeight: "600",
                      color: "#1a1a1a",
                      letterSpacing: "-0.2px",
                    }}
                  >
                    WHITELION
                  </div>
                </div>
                <div
                  style={{
                    fontSize: "13px",
                    color: "#757575",
                    fontWeight: "500",
                  }}
                >
                  now
                </div>
              </div>

              {/* Content */}
              <div style={{ padding: "0 16px 12px" }}>
                <div
                  style={{
                    fontSize: "15px",
                    fontWeight: "600",
                    color: "#1a1a1a",
                    marginBottom: "4px",
                    lineHeight: "1.35",
                    letterSpacing: "-0.3px",
                  }}
                >
                  {data.headings}
                </div>
                <div
                  style={{
                    fontSize: "14px",
                    color: "#424242",
                    lineHeight: "1.45",
                    letterSpacing: "-0.2px",
                  }}
                >
                  {data.contents}
                </div>
              </div>

              {/* Image */}
              {data.global_image && (
                <div style={{ padding: "0 16px 16px" }}>
                  <img
                    src={data.global_image}
                    alt="Notification"
                    style={{
                      width: "100%",
                      borderRadius: "12px",
                      display: "block",
                    }}
                  />
                </div>
              )}
            </div>
          </div>

          {/* Bottom Space */}
          <div style={{ height: data.global_image ? "280px" : "300px" }} />

          {/* Home Indicator */}
          <div
            style={{
              position: "absolute",
              bottom: "8px",
              left: "50%",
              transform: "translateX(-50%)",
              width: "120px",
              height: "5px",
              background: "#1a1a1a",
              borderRadius: "3px",
              opacity: 0.3,
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default Mockup;
